/* eslint-disable quotes */
import React from "react";
import Error from "./error";
import PropTypes from "prop-types";
import {
    // CsvViewer,
    // DocxViewer,
    // VideoViewer,
    // XlsxViewer,
    // XBimViewer,
    PDFViewer,
    PhotoViewerWrapper
    // AudioViewer,
} from "./drivers";
import "./../styles/error.css";
import "./../styles/main.css";
// import withFetching from './fetch-wrapper';

class FileViewer extends React.Component {
    getDriver() {
        /* eslint-disable */
        switch (this.props.fileType && this.props.fileType.toLowerCase()) {
            // case 'csv': {
            //     return withFetching(CsvViewer, this.props);
            // }
            // case 'xlsx': {
            //     const newProps = Object.assign({}, this.props, { responseType: 'arraybuffer' });
            //     return withFetching(XlsxViewer, newProps);
            // }
            case "image/jpeg":
            case "image/tiff":
            case "image/svg+xml":
            case "image/gif":
            case "image/bmp":
            case "image/png":
            case "jpg":
            case "jpeg":
            case "gif":
            case "bmp":
            case "jfif":
            case "png": {
                return PhotoViewerWrapper;
            }
            case "application/pdf":
            case "pdf": {
                return PDFViewer;
            }
            // case 'docx': {
            //     return DocxViewer;
            // }
            // case 'mp3': {
            //     return AudioViewer;
            // }
            // case 'webm':
            // case 'mp4': {
            //     return VideoViewer;
            // }
            // case 'wexbim': {
            //     return XBimViewer;
            // }
            default: {
                return Error;
            }
        }
        /* eslint-enable */
    }

    render() {
        const Driver = this.getDriver();
        return (
            <React.Fragment>
                <Driver {...this.props} />
            </React.Fragment>
        );
    }
}

FileViewer.propTypes = {
    fileType: PropTypes.string,
    filePath: PropTypes.string,
    file: PropTypes.object,
    approveDoc: PropTypes.func,
    rejectDoc: PropTypes.func,
    fileString: PropTypes.string
};

class FileViewerErrorBounded extends React.Component {
    componentDidCatch(error) {
        console.log(error);
    }
    // shouldComponentUpdate(nextProps) {
    //     if(this.props.file!==nextProps.file
    //     || this.props.fileType !== nextProps.fileType
    //     ) {
    //         return true;
    //     }
    //     return false;
    // }
    render() {
        return (<FileViewer {...this.props} />);
    }
    static propTypes={
        file: PropTypes.oneOfType([PropTypes.string,PropTypes.object]),
        fileType: PropTypes.string,
        createNewDocument: PropTypes.func
    }
}

export default FileViewerErrorBounded;
